import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from './Modal';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  isDanger?: boolean;
  isLoading?: boolean;
}

export function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isDanger = false,
  isLoading = false,
}: ConfirmationDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex items-start space-x-4">
        <div className={`p-2 rounded-full ${isDanger ? 'bg-red-500/10' : 'bg-primary/10'}`}>
          <AlertTriangle className={`w-6 h-6 ${isDanger ? 'text-red-500' : 'text-primary'}`} />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-semibold mb-4">{title}</h3>
          {typeof message === 'string' ? (
            <p className="text-light/60">{message}</p>
          ) : (
            message
          )}
        </div>
      </div>

      <div className="flex justify-end space-x-4 mt-8">
        <button
          onClick={onClose}
          className="btn-outline"
          disabled={isLoading}
        >
          {cancelLabel}
        </button>
        <button
          onClick={onConfirm}
          className={`btn ${isDanger ? 'bg-red-500 hover:bg-red-600' : 'btn-primary'}`}
          disabled={isLoading}
        >
          {isLoading ? (
            <span className="flex items-center space-x-2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              <span>Processing...</span>
            </span>
          ) : (
            confirmLabel
          )}
        </button>
      </div>
    </Modal>
  );
}